import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import { watchEffect } from 'vue';
import { BaseSearchFilterDto, CustomMetadataSearchFilterElementDto, EntityCustomMetadataDto } from '@/api';
import { getProviderIconSrc } from '@/utils/provider-icons';
import { VTreeview } from 'vuetify/lib';
import SAvatars from '@/components/SAvatars/SAvatars.vue';
import SEllipsisTooltip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';
import CreationMethodIcon from '@/components/icons/CreationMethodIcon.vue';
import AssetTypeIcon from '@/components/icons/Asset-Type-Icon.vue';
import PlatformIcon from '@/components/icons/Platform-Icon.vue';
import IngestionTypeIcon from '@/components/icons/Ingestion-Type-Icon.vue';
import QualityStatus from '@/components/quality-status/Quality-Status.vue';
import RunStatus from '@/modules/monitors/monitor/common/RunStatus.vue';
import DataUsage from '@/components/usage/Usage.vue';
import Tag from '@/components/tags/Tag.vue';
import Term from '@/components/terms/Term.vue';
import Severity from '@/components/Severity.vue';
import IncidentStatus from '@/components/incidents/Incident-Status.vue';
import MonitorMutingStatus from '@/components/monitors/Monitor-Muting-Status.vue';

interface SearchFilterTreeviewSelectorProps {
  type: string;
  items: { name: string;[key: string]: any }[];
  selectedItems: string[];
  lazyLoading: boolean,
  search: string;
}

type SearchFilterTreeviewSelectorEmit = {
  (event: 'updateSelectedItems', items: string[]): void;
  (event: 'updateLazyLoadingState', isLoading: boolean): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFilterTreeviewSelector',
  props: {
  type: null,
  items: null,
  selectedItems: null,
  lazyLoading: { type: Boolean },
  search: null
},
  emits: ["updateSelectedItems", "updateLazyLoadingState"],
  setup(__props, { emit: emits }) {

const props = __props;




const treeviewRef = _ref<typeof VTreeview | null>(null);

const type = _computed(() => props.type);
const items = _computed(() => props.items);
const lazyLoading = _computed(() => props.lazyLoading);
const selectedItems = _computed({
  get: () => props.selectedItems,
  set: (val: string[]) => {
    emits('updateSelectedItems', val);
  },
});
const search = _computed(() => props.search);

const isAssetType = _computed(() => type.value === BaseSearchFilterDto.type.ASSET_TYPE);
const isPlatform = _computed(() => type.value === BaseSearchFilterDto.type.PLATFORM);
const isTemplate = _computed(() => type.value === BaseSearchFilterDto.type.RULE_TEMPLATE_NAME);
const isHealth = _computed(() => type.value === BaseSearchFilterDto.type.HEALTH_STATUS);
const isUsage = _computed(() => type.value === BaseSearchFilterDto.type.USAGE);
const isTag = _computed(() => type.value === BaseSearchFilterDto.type.TAG);
const isTerm = _computed(() => type.value === BaseSearchFilterDto.type.TERM);
const isCriticality = _computed(() => type.value === BaseSearchFilterDto.type.CRITICALITY);
const isOwner = _computed(() => type.value === BaseSearchFilterDto.type.OWNER);
const isCreatedBy = _computed(() => type.value === BaseSearchFilterDto.type.CREATED_BY);
const isTechnology = _computed(() => type.value === BaseSearchFilterDto.type.TECHNOLOGY);
const isAssetIngestion = _computed(() => type.value === BaseSearchFilterDto.type.ASSET_INGESTION);
const isCreationMethod = _computed(() => type.value === BaseSearchFilterDto.type.CREATION_METHOD);
const isRuleStatus = _computed(() => type.value === BaseSearchFilterDto.type.RULE_STATUS);
const isCustomMetadata = _computed(() => type.value === BaseSearchFilterDto.type.CUSTOM_METADATA);
const isIncidentStatus = _computed(() => type.value === BaseSearchFilterDto.type.INCIDENT_STATUS);
const isMonitorMutingStatus = _computed(() => type.value === BaseSearchFilterDto.type.MONITOR_MUTING_STATUS);
const isTeam = _computed(() => type.value === BaseSearchFilterDto.type.TEAM);
const isDataProduct = _computed(() => type.value === BaseSearchFilterDto.type.DATA_PRODUCT);

// if item has even one children property with lenght > 0
const hasChildren = _computed(() => items.value?.some((item: any) => 'children' in item && item.children?.length));
const wrapperClass = _computed(() => (hasChildren.value ? 'v-treeview--has-children' : 'v-treeview--has-no-children'));
const loading = (item: any) => item.results === null;

const isExternalCatalogMetadata = (customMetadata: CustomMetadataSearchFilterElementDto) => customMetadata.lineagePlatform != null && customMetadata.lineagePlatform !== CustomMetadataSearchFilterElementDto.lineagePlatform.SIFFLET;

// Used to track when rendering of lazy loaded element ends
watchEffect(() => {
  if (treeviewRef.value && lazyLoading.value) {
    emits('updateLazyLoadingState', false);
  }
});

return { __sfc: true,props, emits, treeviewRef, type, items, lazyLoading, selectedItems, search, isAssetType, isPlatform, isTemplate, isHealth, isUsage, isTag, isTerm, isCriticality, isOwner, isCreatedBy, isTechnology, isAssetIngestion, isCreationMethod, isRuleStatus, isCustomMetadata, isIncidentStatus, isMonitorMutingStatus, isTeam, isDataProduct, hasChildren, wrapperClass, loading, isExternalCatalogMetadata, _ref, _computed, watchEffect, BaseSearchFilterDto, CustomMetadataSearchFilterElementDto, EntityCustomMetadataDto, getProviderIconSrc, VTreeview, SAvatars, SEllipsisTooltip, CreationMethodIcon, AssetTypeIcon, PlatformIcon, IngestionTypeIcon, QualityStatus, RunStatus, DataUsage, Tag, Term, Severity, IncidentStatus, MonitorMutingStatus }
}

})